import * as React from "react"
import * as styles from '../styles/heading_elements.module.css'

export function Header1(props) {
    const headerTitle = props.headerTitle
    return (
      <div className={styles.header1}>
        <img className={styles.header1_frame_star} src="sp/frame_star.svg" alt="frame_star"/>
        <p className={styles.header1_text}>{headerTitle}</p>
        <img className={styles.header1_frame_star}  src="sp/frame_star.svg" alt="frame_star"/>
      </div>
    )
  }
  
export function Header2(props) {
    const headerTitle = props.headerTitle
    return (
      <div className={styles.header2}>
        <p className={styles.header2_text}>{headerTitle}</p>
      </div>
    )
  }
  